import { ContentType, request } from "../api";
import { baseParams } from "../common";

export const orderCancel = async (data = {}, params = {}) => request({
  path: "/book-cancel",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  ...params,
});
